import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FilterKey, FilterModule } from '@wilson/filter';
import { ShiftTimelineFilterStateService } from '@wilson/shift-timeline/state';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { map, Observable } from 'rxjs';
import { AbsenceFiltersGroupComponent } from './absence-filters-group/absence-filters-group.component';
import { ClearTimelineFiltersButtonComponent } from './clear-timeline-filters-button/clear-timeline-filters-button.component';
import { ShiftFiltersGroupComponent } from './shift-filters-group/shift-filters-group.component';
import { UserFiltersGroupComponent } from './user-filters-group/user-filters-group.component';

@Component({
  selector: 'wilson-timeline-filter',
  templateUrl: './timeline-filter.component.html',
  styleUrls: ['./timeline-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    FilterModule,
    FontAwesomeModule,
    NzBadgeModule,
    UserFiltersGroupComponent,
    ShiftFiltersGroupComponent,
    AbsenceFiltersGroupComponent,
    ClearTimelineFiltersButtonComponent,
    AuthorizationModule,
  ],
})
export class TimelineFilterComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  protected shiftTimelineFilterStateService = inject(
    ShiftTimelineFilterStateService,
  );

  public faFilter = faFilter;
  public isFilterDrawerVisible$ =
    this.shiftTimelineFilterStateService.showFilterDrawer$;
  public numberOfParams$!: Observable<number>;

  ngOnInit(): void {
    const validFilterKeys: FilterKey[] = [
      'orgUnit',
      'role',
      'absences',
      'shiftCategory',
      'shiftOperationalStatus',
      'releaseStatus',
      'users',
      'priority',
      'profession',
      'labels',
      'projects',
      'agreements',
      'confirmedDeclined',
      'shiftProfession',
      'shiftLabels',
      'shiftOrgUnit',
      'homeLocation',
      'timelineAssignedRegionShiftSearch',
    ];
    this.numberOfParams$ = this.route.queryParams.pipe(
      map((params: Params) => {
        const validParams = Object.keys(params).filter((key) =>
          validFilterKeys.includes(key as FilterKey),
        );
        return validParams.length;
      }),
    );
  }

  public toggleFilterDrawer(drawerVisible: boolean): void {
    this.shiftTimelineFilterStateService.showFilterDrawer = !drawerVisible;
  }

  ngOnDestroy(): void {
    this.shiftTimelineFilterStateService.showFilterDrawer = false;
  }
}
